module.exports = __webpack_public_path__ + "img/small-13.3233fd8e.webp";